import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {getCall, postCall, putCall} from "../../utils/api";
import { startLoading, stopLoading } from "../loading";

const initialState = {
    data: [],
    error: "",
    status: "idle",
};

export const getSettings = createAsyncThunk(
    "Settings/get",
    async () => {
        try {
            return await getCall(`/admin/v1/settings`, false);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const updateSettings = createAsyncThunk(
    "Settings/update",
    async ({ id, formData, showToast = true }) => {
        try {
            return await putCall(`/admin/v1/settings/${id}`, formData, showToast);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

const SettingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSettings.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getSettings.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(getSettings.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(updateSettings.pending, (state) => {
                state.status = "loading";
            })
            .addCase(updateSettings.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(updateSettings.fulfilled, (state, action) => {
                state.status = "succeeded";
            })
    },
});

export default SettingsSlice.reducer;
